import React, { useContext, useEffect, useState } from 'react';
import { AlmanacIcon } from '../icons/Almanac';
import style from './DiscountBadge.module.scss';
import classnames from 'classnames';
import { AlmanacContext } from '../../context/AlmanacContext';

interface IProps {
  discount: number;
}

const DiscountBadge = ({discount}: IProps) => {
  const context = useContext(AlmanacContext);
  const [isShow, setIsShow] = useState(false);
  const handleShow = () => {
    setIsShow(true);
    console.log('show');
  }
  useEffect(() => {
    window.addEventListener('load', handleShow);
    setTimeout(() => {
      setIsShow(true);
    }, 1000);
    return () => {
      window.removeEventListener('load', handleShow);
    }
  }, [])

  return (
    <div onClick={() => context.ref?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })} className={classnames(style.badge, {[style.show]: isShow})}><span className={style.discount}>-{discount}%</span><AlmanacIcon className={style.icon}/></div>
  );
};

export default DiscountBadge;
